import { getCacheBustedUrl } from './cacheBuster';

// Product folder mapping
export const products = [
  {
    folder: 'Styler 7in1',
    image: 'styler series 5 7in1.png',
    manual: 'PG 140-043 Styler 7in1.pdf'
  },
  {
    folder: 'Styler 6in1',
    image: 'Styler 6 in 1.png',
    manual: 'PG 140-042 Styler 6in1.pdf'
  },
  {
    folder: 'Styler 4in1',
    image: 'Styler 4in1.png',
    manual: 'PG 140-041 Styler 4in1.pdf'
  },
  {
    folder: 'Styler 40 lengths Series 3',
    image: 'Styler 40 lengths 7500435244961_BT3560_MN_C1N1_107829388.png',
    manual: 'PG 140-040 Series 3 Styler 40 lengths.pdf'
  },
  {
    folder: 'Styler 11in1',
    image: 'styler series 7 11in1.png',
    manual: 'PG 140-044 Styler 11in1.pdf'
  },
  {
    folder: 'Series 9 Shaver',
    image: 'Series 9 shaver.png',
    manual: 'PG 140-023 Series 9 Shaver.pdf'
  },
  {
    folder: 'Series 6 Shaver',
    image: 'Series 6 shaver.png',
    manual: 'PG 140-022 Series 6 Shaver.pdf'
  },
  {
    folder: 'Series 5 Shaver',
    image: 'Series 5 Shaver.png',
    manual: 'PG 140-021 Series 5 Shaver.pdf'
  },
  {
    folder: 'Series 3 Shaver',
    image: 'Series 3 Shaver.jpeg',
    manual: 'PG 140-020 Series 3 Shaver.pdf'
  },
  {
    folder: 'Oral B IO5',
    image: 'Oral B IO 5.png',
    manual: 'PG 111-041 Oral B IO5.pdf'
  },
  {
    folder: 'Oral B IO2',
    image: 'Oral B IO 2.png',
    manual: 'PG 111-040 Oral B IO2.pdf'
  },
  {
    folder: 'IPL 7432',
    image: 'IPL7432.png',
    manual: 'IPL 7432 Instruction Manual.pdf'
  },
  {
    folder: 'IPL 7147',
    image: 'IPL7147.png',
    manual: 'PG 140-003 IPL 7147.pdf'
  },
  {
    folder: 'IPL 5431',
    image: 'IPL5431.jpeg',
    manual: 'IPL 5431 Instruction Manual.pdf'
  },
  {
    folder: 'IPL 5221',
    image: 'IPL5221.jpeg',
    manual: 'IPL 5221 Instruction Manual.pdf'
  },
  {
    folder: 'IPL 5152',
    image: 'IPL5152.png',
    manual: 'PG 140-001 & PG 140-002 IPL 5052& IPL 5152.pdf'
  },
  {
    folder: 'IPL 5052',
    image: 'IPL5052.png',
    manual: 'PG 140-001 & PG 140-002 IPL 5052& IPL 5152.pdf'
  },
  {
    folder: 'Body Grooming',
    image: 'Body Grooming.png',
    manual: 'PG 140-045 Body Grooming.pdf'
  }
];

export const getProductImagePath = (product) => {
  const path = `/Landing Page Data/${product.folder}/${product.image}`;
  return getCacheBustedUrl(path);
};

export const getProductManualPath = (product) => {
  const path = `/Landing Page Data/${product.folder}/${product.manual}`;
  return getCacheBustedUrl(path);
};

